import { createResourceCollection } from '@/request'
import { EnergySystemDemandResponseEvent } from '@/types/energySystemDemandResponseEvent'

export const energySystemDemandResponseEventsCollection =
  createResourceCollection<EnergySystemDemandResponseEvent>({
    name: 'energySystemDemandResponseEvents',
    computedId: (resource) => resource.dr_event_id,
    selector: (state) => state.energySystemDemandResponseEvents,
  })

export default energySystemDemandResponseEventsCollection.slice.reducer

export function optOutOfEnergySystemDemandResponseEventAction(
  energySystemId: string,
  energySystemDemandResponseEventId: number,
  cancelled_reason: string,
) {
  return energySystemDemandResponseEventsCollection.actions.update(
    `energy-systems/${energySystemId}/dr-events/${energySystemDemandResponseEventId}/opt-out`,
    { cancelled_reason },
    { id: energySystemDemandResponseEventId },
  )
}

export function optInToEnergySystemDemandResponseEventAction(
  energySystemId: string,
  energySystemDemandResponseEventId: number,
) {
  return energySystemDemandResponseEventsCollection.actions.update(
    `energy-systems/${energySystemId}/dr-events/${energySystemDemandResponseEventId}/opt-in`,
    { enrolled: true },
    { id: energySystemDemandResponseEventId },
  )
}
